import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Noto_Kufi_Arabic, Vazirmatn } from 'next/font/google'
import { DirectionProvider } from '@base-ui/react/direction-provider'
import { CartProvider } from '@/components/shop/cart-provider'

const sans = Vazirmatn({
    subsets: ['arabic', 'latin']
})

const heading = Noto_Kufi_Arabic({
    subsets: ['arabic', 'latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:ui-monospace,SFMono-Regular,Menlo,monospace;--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <DirectionProvider direction='rtl'>
                <CartProvider>
                    <Component {...pageProps} />
                </CartProvider>
            </DirectionProvider>
        </div>
    )
}

export default App
